import axiosInstance from './axiosInstance';

export interface ObraSocialOption {
  id: number;
  nombre: string;
}

export interface ObraSocialRequest {
  nombre: string;
}

export async function getObrasSociales(): Promise<ObraSocialOption[]> {
  const response = await axiosInstance.get<ObraSocialOption[]>('/api/obras-sociales');
  return response.data;
}

export async function crearObraSocial(data: ObraSocialRequest): Promise<ObraSocialOption> {
  const response = await axiosInstance.post<ObraSocialOption>('/api/obras-sociales', data);
  return response.data;
}

export async function actualizarObraSocial(id: number, data: ObraSocialRequest): Promise<ObraSocialOption> {
  const response = await axiosInstance.put<ObraSocialOption>(`/api/obras-sociales/${id}`, data);
  return response.data;
}
